module.exports = __webpack_public_path__ + "media/nujabes-windspeaks.6c4db335.mp3";